var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "saas_staff_library_padding" }, [
    _c(
      "div",
      {
        staticClass: "saas_staff_library",
        style: { backgroundColor: _vm.value.config.bg_color || "#fff" },
      },
      [
        _c("div", { staticClass: "header" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.value.config.name)),
          ]),
          _c("div", { staticClass: "more" }, [
            _vm._v(" " + _vm._s(_vm.value.config.more_name) + " "),
            _c("i", { staticClass: "el-icon el-icon-arrow-right" }),
          ]),
        ]),
        _c(
          "div",
          { class: ["container", "layout-" + _vm.value.config.show_type] },
          _vm._l(_vm.bookList, function (item, index) {
            return _c(
              "div",
              { key: index, staticClass: "item" },
              [
                _c(
                  "el-image",
                  { staticClass: "img", attrs: { src: item.pic } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "image-slot",
                        attrs: { slot: "error" },
                        slot: "error",
                      },
                      [_vm._v(" " + _vm._s(index + 1) + " ")]
                    ),
                  ]
                ),
                ["2", "3"].includes(_vm.value.config.show_type + "")
                  ? _c("div", { staticClass: "book_name" }, [
                      _vm._v(" " + _vm._s(item.book_name || "书籍名称") + " "),
                    ])
                  : _vm._e(),
              ],
              1
            )
          }),
          0
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }